import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import Axios from 'axios'
// import './ExercisePage.css'

const ExercisePage = () => {
  const param = useParams();
  const [exercise, setexercise] = useState({});
  const [videos, setvideos] = useState([]);
  const [page, setpage] = useState(0);

  async function fetchExercisesID() {
    const options = {
      method: 'GET',
      url: `https://exercisedb.p.rapidapi.com/exercises/exercise/${param.id}`,
      headers: {
        // 'X-RapidAPI-Key': '0e7fc6e104msh52b62682bb5e81dp1c0598jsn68e749535130',
        'X-RapidAPI-Key': 'a768ccb462mshb6fc37b5af55038p107e38jsn89c8bfa2c507',
        'X-RapidAPI-Host': 'exercisedb.p.rapidapi.com'
      }
    };
    try {
      const response = await Axios.request(options);
      setexercise(response.data);
      const options2 = {
        method: 'GET',
        url: 'https://youtube-v2.p.rapidapi.com/search/',
        params: {
          query: `${response.data.name} exercise videos`,
          lang: 'en'
        },
        headers: {
          // 'X-RapidAPI-Key': '9808f568d4mshc8d984fba3d5b61p1228fbjsnb385acf97595',
          'X-RapidAPI-Key': '8f34428108msh6dbce8077b032eap1f916fjsn462f4690f7be',
          'X-RapidAPI-Host': 'youtube-v2.p.rapidapi.com'
        }
      };

      try {
        const response = await Axios.request(options2);
        setvideos(response.data.videos);
        setpage(1);
      } catch (error) {
        console.error(error);
      }
    } catch (error) {
      console.error(error);
    }
  }

  function displayvideos() {
    let video_cards = document.getElementById('video-cards');
    video_cards.innerHTML = '';
    for (let i = 3 * (page - 1); i < (3 * (page - 1) + 3); i++) {
      let video_card = document.createElement('div');
      video_card.className = 'video-card exercise-card';
      video_card.onclick = () => {
        window.open(`https://www.youtube.com/watch?v=${videos[i].video_id}`, "_blank", "noreferrer");
      };
      let video_image = document.createElement('img');
      video_image.src = videos[i].thumbnails[0].url;
      video_image.alt = '';
      video_card.appendChild(video_image);
      let video_title = document.createElement('h2')
      video_title.className = 'video-title exercise-title';
      video_title.innerText = videos[i].title;
      video_card.appendChild(video_title);
      video_cards.appendChild(video_card);
    }
  }

  useEffect(() => {
    if (videos.length != 0) {
      displayvideos();
    }
  }, [page])

  useEffect(() => {
    fetchExercisesID();
  }, [])

  const left = () => {
    if (videos.length != 0) {
      if (page > 1) {
        setpage(page - 1);
      }
    }
  }
  const right = () => {
    if (videos.length != 0) {
      if (page < Math.floor(videos.length / 3)) {
        setpage(page + 1);
      }
    }
  }


  return (
    <div className='exercise-page'>
      <div className='exercise-container'>
        <div className='exercise-card unique-exercise'>
          <img src={exercise.gifUrl} alt="" />
        </div>
        <div className='exercise-details'>
          <h2> {exercise.name}</h2>
          <p>{exercise.instructions}</p>
        </div>
      </div>
      <hr className='section-line' />
      <div className='videos-container exercise-container'>
        <h2 className='main-heading video-heading'>Watch <span>{exercise.name}</span> Exercise Videos:</h2>
        <div id='video-cards' className='exercise-cards' ></div>

        <div className='paging'>
          <button  className='paging-btn' id="left-btn" type='button' onClick={left} disabled={page==1}>&larr;</button>
          {/* <label>{page} of {Math.floor(videos.length / 3)}</label> */}
          <p>{page}</p>
          <button className='paging-btn'id="right-btn" type='button' onClick={right} disabled={page==Math.ceil(videos.length/3)}>&rarr;</button>
        </div>
        
      </div>
    </div>
  )
}

export default ExercisePage
